"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Times = _interopRequireDefault(require("@paprika/icon/lib/Times"));

var constants = _interopRequireWildcard(require("@paprika/constants/lib/Constants"));

var types = _interopRequireWildcard(require("../../types"));

var sc = _interopRequireWildcard(require("./CloseButton.styles"));

var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** If the close button will be rendered on a dark background and will use inverted colours. */
  isDark: _propTypes["default"].bool
};
var defaultProps = {
  a11yText: null,
  isDark: false
};

var Close = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var buttonProps = {
    a11yText: props.a11yText || "close",
    // TODO: use L10n
    isDark: props.isDark,
    kind: types.MINOR
  };
  return /*#__PURE__*/_react["default"].createElement(sc.CloseButton, (0, _extends2["default"])({}, props, buttonProps, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement(_Times["default"], null));
});

Close.types = {
  kind: constants.kind
};
Close.displayName = "Button.Close";
Close.propTypes = propTypes;
Close.defaultProps = defaultProps;
var _default = Close;
exports["default"] = _default;
//# sourceMappingURL=Close.js.map